import React, { useEffect, useState } from "react";
import "./App.css";
import { VideoPlayerComponent } from "./components";
import "videojs-hotkeys";
import { Base64 } from "./services/encode-utilities";
import videojs from 'video.js';
import { SERVICE_WORKER_MESSAGE_TYPE, sendMessageToServiceWorker } from "./services/utils";
import { getAccessToken, getRandomId } from "./services/api-client";


function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const App = () => {
  const [actions, setAction] = useState({} as any);
  const [videoDetails, setVideoDetails] = useState({} as any);
  const [hideControls, setHideControls] = useState(false);
  const [defaultPaused, setDefaultPaused] = useState(false);
  const [defaultMuted, setDefaultMuted] = useState(false);
  const [loop, setLoop] = useState(false);
  const [type, setType] = useState("" as any);
  const [thumbnail, setThumbnail] = useState("" as any);
  const [showThumbnail, setShowThumbnail] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("#000000");
  const [playerCurrentTime, setPlayerCurrenttime] = useState(0);
  const [url, setUrl] = useState("");
  window.addEventListener("dblclick", (e) => {
    console.log("double click");
  });
  useEffect(() => {
    setServiceWorkerParams();

    console.log("Build: 0.0.6 - production");

    console.log("vp-build: 0.0.7");
    const params: any = new Proxy(new URLSearchParams(location.search), {
      // @ts-ignore
      get: (searchParams, prop) => searchParams.get(prop),
    });
    // @ts-ignore

    // @ts-ignore
    if (params["token"]) {
      // @ts-ignore
      localStorage.setItem("token", params["token"]);
    }
    // @ts-ignore
    if (params["random_id"]) {
      // @ts-ignore
      localStorage.setItem("random_id", params["random_id"]);
    }
    // @ts-ignore
    if (params["window_full_screen"]) {
      // @ts-ignore
      localStorage.setItem(
        "window_full_screen",
        JSON.parse(params["window_full_screen"])
      );
    }
    // @ts-ignore
    if (params["hide_controls"] && params["hide_controls"] === "true") {
      // @ts-ignore
      setHideControls(!!params["hide_controls"]);
    }
    // @ts-ignore
    if (params["default_paused"] && params["default_paused"] === "true") {
      // @ts-ignore
      setDefaultPaused(!!params["default_paused"]);
    }
    // @ts-ignore
    if (params["default_muted"] && params["default_muted"] === "true") {
      // @ts-ignore
      setDefaultMuted(!!params["default_muted"]);
    }
    // @ts-ignore
    if (params["loop"] && params["loop"] === "true") {
      // @ts-ignore
      setLoop(!!params["loop"]);
    }
    // @ts-ignore
    if (params["video_details"]) {
      console.log(
        ">>>>>>VIDEO DETAILS>>>>",
        Base64.decode(params["video_details"])
      );
      // @ts-ignore
      setVideoDetails(
        isJsonString(Base64.decode(params["video_details"]))
          ? JSON.parse(Base64.decode(params["video_details"]))
          : {}
      );
    }
    // @ts-ignore
    if (params["actions"]) {
      // @ts-ignore
      setAction(
        isJsonString(Base64.decode(params["actions"]))
          ? JSON.parse(Base64.decode(params["actions"]))
          : {}
      );
    }
    localStorage.removeItem("player_start_time");
    console.log(params);
    // @ts-ignore
    if (params["start_seconds"]) {
      // @ts-ignore
      localStorage.setItem("player_start_time", params["start_seconds"] || 0);
    }
    // @ts-ignore
    if (params["thumbnail"]) {
      // @ts-ignore
      setThumbnail(params["thumbnail"]);
      setShowThumbnail(true);
    }
    // @ts-ignore
    if (params["background_color"]) {
      // @ts-ignore
      setBackgroundColor(params["background_color"]);
    }
    console.log("VIDEO TYPE>>>>>", params["type"]);
    // @ts-ignore
    setType(params["type"] || "MP4");

    const sampleUrl =
      "https://file-examples.com/storage/fe3f7d476663e91319de1d9/2017/04/file_example_MP4_480_1_5MG.mp4";
    // @ts-ignore
    if (params["encoded_url"]) {
      // @ts-ignore
      setUrl(Base64.decode(params["encoded_url"]) || sampleUrl);
    } else {
      // @ts-ignore
      setUrl(params["src"] || params["url"] || sampleUrl);
    }
  }, []);


  const setServiceWorkerParams = () => {
    const browser = videojs.browser;
    // let HLStype = false;

  const isSafari =
    browser &&
    (browser['IS_SAFARI'] ||
      browser['IS_IOS'] ||
      browser['IS_IPAD'] ||
      browser['IS_IPHONE'] ||
      browser['IS_IPOD']);
      sendMessageToServiceWorker(SERVICE_WORKER_MESSAGE_TYPE.UPDATE_IS_SAFARI, isSafari);
      if(isSafari){
        console.log('issafari APP', isSafari);
        sendMessageToServiceWorker(SERVICE_WORKER_MESSAGE_TYPE.UPDATE_HEADERS, {
          randomId: getRandomId(),
          authorization: getAccessToken(),
        });
      }
    };
  return (
    <div
      className={`mainWrapper ${actions?.BACK && "display-back-button"} 
             ${hideControls && "hide-controls"} 
             ${actions?.REPORT && "display-report-button"}  
             ${actions?.FULL_SCREEN && "display-fullscreen-button"}  
             ${actions?.CHAT && "display-chat-button"} 
             ${actions?.DOUBTS && "display-doubts-button"}  
             ${actions?.COMMENT && "display-comment-button"}  
             ${actions?.DOCUMENT && "display-documentation-button"}  
             ${actions?.TIMELINE && "display-timeline-button"} 
             ${actions?.PLAYLIST && "display-playlist-button"} 
             ${actions?.THREEDICON && "display-3d-button"}
             ${actions?.ASKSAARTHI && "display-ask-saarthi-button"}
             ${actions?.POLLBUTTON && "display-poll-button"}
             ${actions?.THREEDOTS && "display-three-dots-button"}
             `}
    >
      {showThumbnail && thumbnail ? (
        <div
          className={"vjs-video-thumbnail"}
          style={{
            backgroundImage: `url("${thumbnail}")`,
            backgroundColor,
          }}
        >
          <div className={"vjs-thumbnail-overlay"}>
            <div
              className={"play-icon"}
              onClick={() => setShowThumbnail(false)}
            >
              Play
            </div>
          </div>
        </div>
      ) : (
        <div className="mainWrapper">
          <div id="actions-animation"></div>
          <VideoPlayerComponent
            goToTime={playerCurrentTime}
            actions={actions}
            type={type as any}
            videoDetails={videoDetails}
            src={url}
            defaultPaused={defaultPaused}
            defaultMuted={defaultMuted}
            loop={loop}
          />
        </div>
      )}
    </div>
  );
};

export default App;
